window._mode='front';window._protocol='https://';window._domain='www.votre-etiquette.com';window._diroot='';window._theme='default';window._webdir='web';window._themedir='web/_themes/ve/';window._api='/api/v2/';
import Interface from 'theme/index.js';
import Product from 'assets/shop/components/product.js';
import Set_cart from 'assets/shop/components/buttons_cart.js';
import Plus_minus from 'assets/shop/components/buttons_plus_minus.js';
import Storage from 'components/storage.js';

(async () => {
    await Interface();

    Plus_minus();
    Set_cart();

    // Bind change attribute
    if (document.querySelectorAll('.shop-attribute-color').length > 0)
    {
        Array.from(document.querySelectorAll('.shop-attribute-color')).forEach(e =>
        {
            e.addEventListener('click', event =>
            {
                document.querySelector('.shop-attribute-color.activ').classList.remove('activ');
                e.classList.add('activ');
                const chk = e.nextElementSibling;
                chk.checked = true;
                const id_product = e.getAttribute('data-id_product');

                Product.get_price({
                    id_product: id_product,
                    quantity: document.getElementById(`shop-quantity-${id_product}`).value
                });

                return false;
            });
        });
    }

    if (document.querySelectorAll('.shop-attribute-group-radio input[type="radio"]').length > 0)
    {
        Array.from(document.querySelectorAll('.shop-attribute-group-radio input[type="radio"]')).forEach(e =>
        {
            e.addEventListener('click', event =>
            {
                const id_product = e.closest('.shop-attribute-group-radio').getAttribute('data-id_product');
                Product.get_price({
                    id_product: id_product,
                    quantity: document.getElementById(`shop-quantity-${id_product}`).value
                });
                const id_product_attribute = document.getElementById(`shop-product-attribut-${id_product}`).value;
            });
        });

    }

    if (document.querySelectorAll('.shop-product-attribute-switch').length > 0)
    {
        Array.from(document.querySelectorAll('.shop-product-attribute-switch')).forEach(e =>
        {
            e.addEventListener('change', event =>
            {
                const id_product = e.getAttribute('data-id_product');
                
                    Product.get_price({
                        id_product: id_product,
                        quantity: document.getElementById(`shop-quantity-${id_product}`) ? document.getElementById(`shop-quantity-${id_product}`).value : 1
                    });

                    const id_product_attribute = document.getElementById(`shop-product-attribut-${id_product}`).value;

                    const gift_link = Storage.get('product_gift_link', 'shop', 'session');

                    Array.from(document.querySelectorAll('.shop-set-url-attribute')).forEach(f =>
                    {
                        f.setAttribute('onclick', `document.location='${gift_link}?id_product_attribute=${id_product_attribute}';`);
                    });
                
            });
        });

    }

    if (document.querySelectorAll('.shop-quantity-switch').length > 0)
    {
        Array.from(document.querySelectorAll('.shop-quantity-switch')).forEach(e =>
        {
            e.addEventListener('change', event =>
            {
                const id_product = e.getAttribute('data-id_product');
                Product.get_price({
                    id_product: id_product,
                    from_price: false,
                    quantity: document.getElementById(`shop-quantity-${id_product}`).value
                });
            });
        });
    }

    if (document.querySelectorAll('.shop-quantity-field').length > 0)
    {
        Array.from(document.querySelectorAll('.shop-quantity-field')).forEach(e =>
        {
            e.addEventListener('change', event =>
            {
                const id_product = e.getAttribute('data-id_product');
                Product.get_price({
                    id_product: id_product,
                    from_price: false,
                    quantity: document.getElementById(`shop-quantity-${id_product}`).value
                });
            });
        });
    }



    if (document.getElementById('shop-product-carriers-simulation-more') && document.getElementById('shop-product-carriers-simulation-more-button'))
    {
        document.getElementById('shop-product-carriers-simulation-more').addEventListener('show.bs.collapse', event => {
            document.getElementById('shop-product-carriers-simulation-more-button').innerHTML = document.getElementById('shop-product-carriers-simulation-more-button').getAttribute('data-label-less');
        });

        document.getElementById('shop-product-carriers-simulation-more').addEventListener('hidden.bs.collapse', event => {
            document.getElementById('shop-product-carriers-simulation-more-button').innerHTML = document.getElementById('shop-product-carriers-simulation-more-button').getAttribute('data-label-more');
        });
    }


    document.querySelectorAll('.product-thumbnails').forEach(thumbnail =>
    {
        thumbnail.addEventListener('mouseover', () =>
        {
            const thumbnailLargePicSrc = thumbnail.getAttribute('data-large-image');
            const thumbnailThickboxPicSrc = thumbnail.getAttribute('data-thickbox-image');
            const thumbnailPicAlt = thumbnail.getAttribute('alt');

            const productImg = document.getElementById('product-img');
            const shopProductGalleryImg = document.querySelector('#shop-product-gallery.modal img');

            if (thumbnail.getAttribute('data-index') !== null && thumbnail.getAttribute('data-index'))
            {
                const figure = document.getElementById('product-img-block');
                figure.setAttribute('data-fancybox-index', parseInt(thumbnail.getAttribute('data-index')) - 1);
            }

            productImg.setAttribute('src', thumbnailLargePicSrc);
            productImg.setAttribute('data-src', thumbnailLargePicSrc);
            productImg.setAttribute('alt', thumbnailPicAlt);
            
            if (shopProductGalleryImg)
            {
                shopProductGalleryImg.setAttribute('src', thumbnailThickboxPicSrc);
                shopProductGalleryImg.setAttribute('data-src', thumbnailThickboxPicSrc);
                shopProductGalleryImg.setAttribute('alt', thumbnailPicAlt);
            }
        });
    });
})();